import './plugins/app';

// Disabled until we figure out how to deal with blank pages (old JS file deleted)
// import './registerServiceWorker';

import '@vertical-plus/vue-js-components';
import '@vertical-plus/vue-js-micro-service-components';
import '@vertical-plus/vue-js-micro-service-components/lib/plugins/micro-service';

import 'prismjs/themes/prism.css';
import App from '@/app/index.vue';
import Attachment from './components/attachment/index.vue';
import BreadcrumbComponent from './components/breadcrumb/index.vue';
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import VueScrollTo from 'vue-scrollto';
import i18n from './i18n';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

Vue.config.productionTip = false;

Vue.use(VueApexCharts);
Vue.component('ApexChart', VueApexCharts);

Vue.use(VueScrollTo);

// Register components used within this project multiple times globally
Vue.component('app-attachment', Attachment);
Vue.component('app-breadcrumb', BreadcrumbComponent);

new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app');